import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewEncapsulation, ElementRef, ViewChild, Optional } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ComponentBase } from '../../../classes/base/component-base';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/primeng';
import { FileType } from '../../../../dapfood/common/constant';
import { VsFileItem } from '../models/file-item';
@Component({
    selector: 'file-viewer',
    templateUrl: './file-viewer.component.html',
    styleUrls: ['./file-viewer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FileViewerComponent extends ComponentBase implements OnInit {
    @ViewChild('container') container!: ElementRef;
    scale = 100;
    top = 0;
    left = 0;
    dragging = false;
    rotation: number = 0;
    lastMouseX: number = 0;
    lastMouseY: number = 0;

    offsetX: number = 0;
    offsetY: number = 0;

    isPopupVisible = false;
    popupPosition = { x: 0, y: 0 };

    selectedIndex: number = 0;
    isShowDestroyConfirm: boolean = false;
    fileType = FileType;

    listFile: VsFileItem[] = [];
    file: VsFileItem;

    isShowRejectReason: boolean = false;
    rejectReason: string = '';

    @Output() emitDataImage = new EventEmitter<any>();
    constructor(
        @Optional() public ref: DynamicDialogRef,
        private config: DynamicDialogConfig
    ) {
        super();
    }

    async ngOnInit() {
        //window.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
        await this.showPopup(this.config.data.file, this.config.data.listFile || [], this.config.data.optionBrowse, this.config.data.obj);
    }

    // ngOnDestroy(): void {
    //     window.removeEventListener('wheel', this.onWheel.bind(this));
    // }

    // Sử dụng với file list idFile
    async showPopup(item: VsFileItem, data: VsFileItem[] = [], optionBrowse: number = -1, obj: any = null) {

        this.listFile = data.filter(x => x.type == FileType.Image || x.type == FileType.Video);  // Chỉ view file image và video
        if (this.listFile && this.listFile.length > 0) {
            this.listFile.forEach(item => {

                item.type = FileType.Image;  // Mặc định là kiểu ảnh
                item.link = this.getImageOriginal(item.id);  // mặc định là theo kiểu ảnh

                if (item.type == FileType.Video) {
                    item.type = FileType.Video;
                    item.link = `${environment.apiDomain.fileEndpoint}${this.file.path}`;
                }
            });

            // Nếu không truyền vào ảnh hiển thị mặc định thì lấy ảnh đầu tiên trong listFile
            if (item == null) {
                this.file = this.listFile[0];
            }
        }

        if (item) {
            this.file = item;
            this.file.link = this.getImageOriginal(this.file.id);  // mặc định là theo kiểu ảnh
            this.file.type = this.file.type ? this.file.type : FileType.Image;  // Mặc định là kiểu ảnh
        }
    }

    // // Sử dụng với List Object File
    // showPopupObject(file: any, data: any[] = []) {

    //     if (data.length > 0) {
    //         this.listFile = data.filter(x => x.type == 1);  // Chỉ view file image và video
    //     }

    //     this.file = file;
    //     if (this.file.type == 3)
    //         this.file.url = `${environment.apiDomain.fileEndpoint}${this.file.path}`;
    //     else
    //         this.file.url = this.getImageOriginal(this.file.id);

    //     this.idPharmacy = file.idPharmacy;
    // }

    // Duyệt ảnh trưng bày, viếng thăm
    onAccepted(item: any, e) {
        const obj = {
            id: item.id,
            isAccepted: e.checked
        };

        if (this.ref) {
            this.ref.close(obj);
        }
    }

    onAcceptedDisplay(item: any, checked) {
        const obj = {
            id: item.id,
            isAccepted: true
        };
        if (this.ref) {
            this.ref.close(obj);
        }
    }

    onDestroyeddDisplay(item: any, checked) {
        const obj: any = {
            id: item.id,
            isAccepted: false,
            note: item.note
        };
        if (this.ref) {
            this.ref.close(obj);
        }
    }

    DestroyConfirmDisplay(check: boolean = false) {
        // this.showFileDialog = false;
        this.isShowRejectReason = true;
        this.rejectReason = '';
    }

    // end duyệt
    getCurrent(item: any, index: number) {
        const currentIndex = this.listFile.indexOf(item);
        this.selectedIndex = currentIndex;
        this.file = this.listFile[currentIndex];
        // this.file.url = item.path ? this.getImageOriginal(this.file.id) : this.file.url;
        this.scale = 100;
        this.rotation = 0;
    }

    onNext() {
        this.scale = 100;
        this.rotation = 0;
        if (this.file == null || this.listFile == null || this.listFile.length <= 0) return;
        const currentIndex = this.listFile.indexOf(this.file);

        const nextIndex = (currentIndex + 1) % this.listFile.length;
        this.file = this.listFile[nextIndex];
        // this.file.url = this.file.path ? this.getImageOriginal(this.file.id) : this.file.url;
        this.selectedIndex = nextIndex;
    }

    onPrev() {
        this.scale = 100;
        this.rotation = 0;
        if (this.file == null || this.listFile == null || this.listFile.length <= 0) return;
        const currentIndex = this.listFile.indexOf(this.file);
        let prevIndex = 0;
        if (currentIndex <= 0)
            prevIndex = this.listFile.length - 1;
        else
            prevIndex = currentIndex - 1;

        // prevIndex = (currentIndex - 1) % this.listFile.length;
        this.file = this.listFile[prevIndex];
        // this.file.url = this.file.path ? this.getImageOriginal(this.file.id) : this.file.url;
        this.selectedIndex = prevIndex;
    }

    @HostListener('window:keydown', ['$event'])
    onKeydownHandler(event: KeyboardEvent) {
        // event.preventDefault();
        if (event.key === 'ArrowLeft') {
            //if (event.keyCode == 37) {
            this.onPrev();
        }
        if (event.key === 'ArrowRight') {
            this.onNext();
        }
    }

    @HostListener('document:click', ['$event'])
    clickOutside(event: MouseEvent) {
        this.isPopupVisible = false;
    }

    // urlFile(file) {
    //     if (file.path == null || file.path == undefined)
    //         return `/assets/images/no_image.jpg`; 
    //     return `https://docs.google.com/viewerng/viewer?url=https://wmapi.friends.vn/file.api//2023/9/23/mickey-tai-lieu-api_20230923115008708.docx`;
    // }

    // command menu

    openPopup(event: MouseEvent, item: any) {

        let posX = event.clientX;
        let posY = event.clientY;

        const popupWidth = 150;
        const popupHeight = 100;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        if (posX + popupWidth > viewportWidth) {
            posX = viewportWidth - popupWidth;
        }

        if (posY + popupHeight > viewportHeight) {
            posY = viewportHeight - popupHeight;
        }

        this.popupPosition = { x: posX, y: posY };
        this.isPopupVisible = true;
    }

    // @HostListener('document:click')
    // closePopup() {
    //     this.isPopupVisible = false;
    // }

    closePopup() {
        this.ref.close(null);
    }

    // zoom ảnh
    onMouseDown(event: MouseEvent, image: HTMLImageElement): void {

        if (event.button !== 0) {
            return;
        }

        this.dragging = true;
        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;

        image.style.cursor = 'grabbing';
    }

    onMouseMove(event: MouseEvent): void {
        if (!this.dragging) return;

        const deltaX = event.clientX - this.lastMouseX;
        const deltaY = event.clientY - this.lastMouseY;

        // this.left += deltaX;
        //this.top += deltaY;
        this.offsetX += deltaX;
        this.offsetY += deltaY;


        this.lastMouseX = event.clientX;
        this.lastMouseY = event.clientY;
    }

    onMouseUp(): void {
        this.dragging = false;
    }

    @HostListener('window:wheel', ['$event'])
    onWheel(event: WheelEvent): void {
        const isInside = this.container.nativeElement.contains(event.target as Node);

        if (isInside) {
            event.preventDefault();
            let newScale = this.scale - event.deltaY * 0.2;
            newScale = Math.max(newScale, 100);
            newScale = Math.min(newScale, 500);

            this.scale = newScale;
        }
    }

    rotateImage(angle: number): void {
        this.rotation = (this.rotation + angle) % 360; // Xoay ảnh, giữ giá trị trong khoảng 0-360
    }

    @HostListener('document:keydown.escape', ['$event'])
    handleEscape(event: KeyboardEvent) {
        if (this.ref) {
            this.ref.close();
        }
    }
}
